import { RecentActivities } from '@/interfaces/dashboard/recent-activities';
import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderPipe } from 'ngx-order-pipe';

import { RecentActivitiesService } from '@/services/recent-activities/recent-activities.service';
import { State } from '@/store/login/reducer';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';

@Component({
  selector: 'app-table-recent-activities',
  templateUrl: './table-recent-activities.component.html',
  styleUrls: ['./table-recent-activities.component.css'],
})
export class TableRecentActivitiesComponent {
  panelOpenState = false;
  arrowUp: boolean = true;
  arrowDown: boolean = false;
  infoActivity: boolean = false;

  /// togle table
  showInfo: boolean = true

  userData: Partial<State> = {};
  activitiesLoading: boolean = true;
  activitiesError: string = 'DEFAULT';
  constructor(
    private activitiesService: RecentActivitiesService,
    private store: Store<StoreState>,
    private orderPipe: OrderPipe,
  ) {
    getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.userData = userData;
        this.getAllActivities();
      },
    });
    this.activitiesUser = this.activitiesUser.slice();
    this.sortedCollectionActivities = this.orderPipe.transform(this.activitiesUser, 'id');

  }

  activitiesUser: RecentActivities[] = []

  getAllActivities() {
    const userId = this.userData.mdmid;

    if (userId) {
      const requestData = this.activitiesService.getRecentActivities(userId);
      requestData.subscribe({
        next: (response) => {
          this.activitiesUser = response.sort((a, b) => {
            if (a.createdAt > b.createdAt) {
              return -1;
            }
            if (a.createdAt < b.createdAt) {
              return 1;
            }
            return 0;
          }).slice(0, 5);
          this.activitiesLoading = false;
        },
        error: () => {
          this.activitiesUser = [];
          this.activitiesLoading = false;
          this.activitiesError = 'Ha ocurrido un error al intentar obtener la información asociada a solicitudes recientes.';
        },
      });
    }
  }

  //  ------> sorting activities  <-------
  order: string = ' '
  reverse: boolean = false;
  orderStatus: 1 | 2 | 3 = 1;
  // showIconArrow :Boolean = false;

  sortedCollectionActivities: Partial<RecentActivities[]>;

  setOrder(headerName: string) {
    if (this.order !== headerName) {
      this.orderStatus = 2;
      this.order = headerName;
    }
    else if (this.orderStatus < 3) {
      this.orderStatus++;
    }
    else {
      this.orderStatus = 1;
      this.order = '';
    }

    if (this.orderStatus === 3) {
      this.reverse = true;
    }
    else {
      this.reverse = false;
    }
  }

  getSortingStatusImage(orderStatus: 1 | 2 | 3, arrow: 'UP' | 'DOWN') {
    if (arrow === 'UP') {
      if (orderStatus === 2) {
        return 'assets/img/arrow_r_g.png';
      }
      return 'assets/img/arrow_b_g.png';

    }

    if (orderStatus === 3) {
      return 'assets/img/arrow_r_g.png';

    }
    return 'assets/img/arrow_b_g.png';
  }

}
